import React from 'react';
import { DEFAULT_PRIORITIES, level_options } from './gen_config';
import type { GenRule, TierField } from './gen_config';
import { FIELD_CLASS, fieldStyle } from './ui';

interface Props {
  rule: GenRule & { no_book_day_zero_override?: boolean };
  levels: string[] | null | undefined;
  priorities: string[] | null | undefined;
  disabled: boolean;
  on_change: (field: TierField, value: string) => void;
}

// Visible on stacked (phone) rows; the desktop table has column headers instead.
const CELL_LABEL = 'text-[11.5px] text-content-muted lg:sr-only';

// Level and Priority cells of one rule row (RuleRow's grid places them). Tasks are created
// at any hour; the global call window (GlobalSettingsCard) only marks off-hours rows.
function RuleTierControls({ rule, levels, priorities, disabled, on_change }: Props) {
  const id = `rule-tier-${rule.task_type}`;
  const prio_list = priorities && priorities.length ? priorities : DEFAULT_PRIORITIES;
  const fade = { opacity: disabled ? 0.5 : 1 };
  return (
    <>
      <div className="col-start-2 flex min-w-0 flex-col gap-0.5 lg:col-start-auto" style={fade}>
        <label htmlFor={`${id}-level`} className={CELL_LABEL}>
          Level
        </label>
        <select
          id={`${id}-level`}
          value={rule.level ?? ''}
          disabled={disabled}
          onChange={(e) => on_change('level', e.target.value)}
          className={FIELD_CLASS}
          style={fieldStyle('100%')}
        >
          {rule.level === null || rule.level === undefined ? <option value="">—</option> : null}
          {level_options(rule, levels).map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
      <div className="flex min-w-0 flex-col gap-0.5" style={fade}>
        <label htmlFor={`${id}-priority`} className={CELL_LABEL}>
          Priority
        </label>
        <select
          id={`${id}-priority`}
          value={rule.priority || ''}
          disabled={disabled}
          onChange={(e) => on_change('priority', e.target.value)}
          className={FIELD_CLASS}
          style={fieldStyle('100%')}
        >
          {rule.priority ? null : <option value="">—</option>}
          {prio_list.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}

export default RuleTierControls;
